import OmAlert from '../ui/OmAlert';

const ErrorMessage = ({ isError, message }) => {
  if (!isError || !message) return null;

  return (
    <div className="mb-6 animate-fade-in" style={{
      '--omk-alert-error-strip-color': '#dc2626',
      '--omk-alert-error-background-color': 'rgba(220, 38, 38, 0.05)',
      '--omk-alert-icon-colour': '#dc2626',
      '--omk-alert-title-text-colour': '#dc2626',
      '--omk-alert-message-text-colour': 'rgba(220, 38, 38, 0.9)',
      '--omk-alert-border-radius': '0.5rem'
    }}>
      <OmAlert
        alertType="error"
        icon="error"
        alertTitle="Error"
        message={message}
      />
    </div>
  );
};

export default ErrorMessage;
